import React, { useState } from 'react'

import Tab from '@mui/material/Tab'
import { useIntl } from 'react-intl'
import Tabs from '@mui/material/Tabs'
import Card from '@mui/material/Card'
import { useTheme } from '@mui/material'
import SwipeableViews from 'react-swipeable-views'
import CardContent from '@mui/material/CardContent'

import Page from '../../../components/Page'
import useUser from '../../../hooks/useUser'
import { useSiteConfig } from '../../../hooks'
import LoanDrafts from './components/LoanDrafts'
import withAuth from '../../../components/withAuth'
import TabPanel from '../../../components/TabPanel'
import { a11yProps } from '../../../services/helper'
import PipelineTable from './components/PipelineTable'
import PipelineProvider from './providers/PipelineProvider'

function Pipeline() {
	const themeMUI = useTheme()
	const { formatMessage } = useIntl()
	const { isBorrower, isLoanOfficer } = useUser()

	const siteConfig = useSiteConfig()

	const siteConfigLoading = siteConfig.isLoading
	const localPipeline =
		siteConfig.siteConfig?.losSettings?.useLocalPipeline

	const [activeTab, setActiveTab] = useState(0)

	const pageTitle = isBorrower
		? formatMessage({ id: 'pipeline.my_applications' })
		: formatMessage({ id: 'pipeline.loan_applications' })

	const handleTabChange = (
		_event: React.SyntheticEvent,
		newValue: number
	) => {
		setActiveTab(newValue)
	}

	const handleChangeIndex = (index: number) => {
		setActiveTab(index)
	}

	return (
		<Page page="app-pipeline" title={pageTitle} isFullWidth>
			<PipelineProvider>
				<div className="pl-5 pr-5 pb-10 h-full">
					{isLoanOfficer ? (
						<>
							<Tabs
								aria-label={formatMessage({
									id: 'pipeline.tabs_aria_label',
								})}
								variant="scrollable"
								scrollButtons="auto"
								value={activeTab}
								onChange={handleTabChange}
							>
								<Tab
									label={formatMessage({
										id: 'pipeline.loan_pipeline_tab',
									})}
									{...a11yProps(0)}
								/>
								<Tab
									label={formatMessage({
										id: 'pipeline.incomplete_loans_tab',
									})}
									{...a11yProps(1)}
								/>
							</Tabs>
							{/** @ts-ignore */}
							<SwipeableViews
								axis={
									themeMUI.direction === 'rtl' ? 'x-reverse' : 'x'
								}
								index={activeTab}
								onChangeIndex={handleChangeIndex}
							>
								<TabPanel
									value={activeTab}
									index={0}
									dir={themeMUI.direction}
								>
									<Card>
										<CardContent>
											<PipelineTable
												pageTitle={pageTitle}
												siteConfigLoading={siteConfigLoading}
												localPipeline={localPipeline}
											/>
										</CardContent>
									</Card>
								</TabPanel>
								<TabPanel
									value={activeTab}
									index={1}
									dir={themeMUI.direction}
								>
									<Card>
										<CardContent>
											<LoanDrafts />
										</CardContent>
									</Card>
								</TabPanel>
							</SwipeableViews>
						</>
					) : (
						<PipelineTable
							pageTitle={pageTitle}
							siteConfigLoading={siteConfigLoading}
							localPipeline={localPipeline}
						/>
					)}
				</div>
			</PipelineProvider>
		</Page>
	)
}

export default withAuth(Pipeline)
